import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardJump from '@swf/core/hooks/useWizardJump';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Verify_account,
  TXTWCL_Please_upload_your_official_ID_ELL,
  TXTWCL_This_will_only_take_a_few_minu_ELL_1,
  TXTWCL_Verify_Your_Account
} from './VerificationExhausted.messages.json';

interface Props {
  onClose(): void;
}

const VerificationExhausted: React.FC<Props> = ({ onClose }) => {
  const wizardJump = useWizardJump();

  const jumpToRMFVerification = () => wizardJump.jumpForward('#rmf.rmf-verification');

  const closeAndJumpToRMFVerification = () => {
    onClose?.();
    jumpToRMFVerification();
  };

  return (
    <Prompt
      onClose={closeAndJumpToRMFVerification}
      variant="success"
      title={{ translation: TXTWCL_Verify_Your_Account }}
      primaryButton={{ translation: TXTCLI_Verify_account }}
      onPrimaryButtonClick={jumpToRMFVerification}
    >
      <Typography>
        <Translation {...TXTWCL_Please_upload_your_official_ID_ELL} />{' '}
        <Translation {...TXTWCL_This_will_only_take_a_few_minu_ELL_1} />
      </Typography>
    </Prompt>
  );
};

export default VerificationExhausted;
